import { useEffect } from 'react';
import { useResetRecoilState, useSetRecoilState } from 'recoil';
import { structureIsolationActiveState } from '~/state/atoms/structureSet/roiAtoms';

export function useDimOtherStructures(enabled: boolean): void {
    const setIsolation = useSetRecoilState(structureIsolationActiveState);
    const resetIsolation = useResetRecoilState(structureIsolationActiveState);

    useEffect(() => {
        if (!enabled) {
            return;
        }
        setIsolation(true);
        return resetIsolation;
    }, [enabled, setIsolation, resetIsolation]);
}
